(function () {
	const searchModal = () => {
		$(".search-modal-trigger,.search-modal__overlay,.search__close").click(
			function (e) {
				e.preventDefault();
				searchToggle();
			}
		);

		// Click outside to close modal
		$(document).on('click', function(e) {
			if ($("#search-modal").hasClass("active")) {
				if (!$(e.target).closest('.search__content').length && 
					!$(e.target).closest('.search-modal-trigger').length) {
					searchToggle();
				}
			}
		});
	};
	$(document).on("keyup", function (e) {
		if ($(".search-modal").hasClass("active") && e.key == "Escape") {
			searchToggle();
		}
	});
	function searchToggle() {
		$("#search-modal").toggleClass("active");
		$(".header-overlay").toggleClass("color-background-1");
		if ($("#search-modal").hasClass("active")) {
			$("#search-modal").find(".search__input").focus();
			$(".header-overlay").addClass("color-background-1");
		} else {
			$(".search-modal-trigger").focus();
		}
		// $("body").toggleClass("overflow-hidden");
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
